import React, { Component } from "react"

import "./liveResults.scss"

class LiveResults extends Component {
  render() {
    return (
      <div className="live-results-container">
        <iframe
          className="live-results-iframe"
          src="https://data.surveygizmo.com/r/59150_5df003e643a683.64782676"
          width="100%"
          height="100%"
          style={{ position: "static" }}
        ></iframe>
      </div>
    )
  }
}

export default LiveResults
